import axios from 'axios';
import { appConfig } from '../../config';

export enum LogType {
  Info = 'INFO',
  Warn = 'WARN',
  Error = 'ERROR',
}

interface SendLogMessageToApiProps {
  message: string;
  type: LogType;
}

export const sendLogMessageToApi = async ({
  message,
  type,
}: SendLogMessageToApiProps) => {
  try {
    await axios.post(
      `${appConfig.apiUrl}v1/log`,
      { message, type },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  } catch (error) {
    console.error('Failed to send log message:', error);
  }
};
